import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import "rxjs/add/operator/map";
import { InterceptorService } from "ng2-interceptors";
import { Router } from "@angular/router";
import { ServiceConfig } from "./service-config";

@Injectable()
export class AuthenticationService {
  private host = ServiceConfig.host;

  constructor(
    private http: Http,
    private router: Router,
    private _http: InterceptorService
  ) {}

  public auth(provider: string, authConfig: any): void {
    localStorage.setItem("authConfig", JSON.stringify(authConfig));
    localStorage.setItem("provider", provider);

    if (provider === "facebook" && !this.isLoggedIn()) {
      console.log("send request!");
      window.location.href =
        "https://www.facebook.com/v2.8/dialog/oauth?client_id=" +
        authConfig.facebook.clientId +
        "&redirect_uri=" +
        authConfig.facebook.redirectURI +
        "&scope=email,publish_pages,manage_pages";
    }
  }

  socialLogin(
    code: any,
    clientId: any,
    redirectURI: any,
    authEndpoint: any
  ): Promise<any> {
    const body = { code: code, clientId: clientId, redirectUri: redirectURI };

    return this._http
      .post(authEndpoint, body, {})
      .toPromise()
      .then((r: Response) => {
        console.log(JSON.stringify(r.json()));
        localStorage.setItem("currentSmmAccount", JSON.stringify(r.json()));
        return r.json();
      })
      .catch(this.handleError);
    // return Observable.of(true).delay(1000).do(val => this.isLoggedIn = localStorage.getItem('isLoggedIn'));
  }

  login(inputBody) {
    const headers = new Headers({
      "Content-type": "application/json",
    });

    const options = new RequestOptions({ headers: headers });
    const url = this.host + "/oauth/login";

    const body = JSON.stringify({
      grant_type: "password",
      username: inputBody.username,
      password: inputBody.password,
      ip: inputBody.ip || null,
      captcha: inputBody.captcha,
      captchaId: inputBody.captchaId
    });

    return this.http
      .post(url, body, options)
      .map((response: Response) => response.json())
      .do((data) => {
        // login successful if there's a jwt token in the response
        if (data["success"]) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem(
            "currentSmmAccount",
            JSON.stringify(data.account)
          );
          localStorage.setItem("currentSmmData", JSON.stringify(data));
        }
      });
  }

  forgetPassword(email: string, captcha: string, captchaId: string) {
    const headers = new Headers({
      "Content-type": "application/json",
    });

    const options = new RequestOptions({ headers: headers });
    const url = this.host + "/oauth/resetPassword";

    const body = JSON.stringify({ email: email, captcha, captchaId });
    return this.http
      .post(url, body, options)
      .map((response: Response) => response.json())
      .do((data) => {
        if (data["success"]) {
          console.log(data);
        }
      });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentSmmAccount");
    localStorage.removeItem("currentSmmData");
  }

  public isLoggedIn(): boolean {
    return !!localStorage.getItem("currentSmmAccount");
  }

  private handleError(error: any): Promise<any> {
    console.log(error);
    return Promise.reject(error.message || error);
  }

  resetPassword(token: String) {
    const headers = new Headers({
      "Content-type": "application/json",
    });
    const options = new RequestOptions({ headers: headers });
    const url = this.host + "/oauth/resetPassword?token=" + token;
    console.log(url);
    return this.http
      .get(url, options)
      .map((response: Response) => response.json());
  }

  getCaptcha() {
    const headers = new Headers({
      "Content-type": "application/json",
    });
    const options = new RequestOptions({ headers: headers });
    const url = this.host + "/oauth/login/captcha";
    return this.http
      .get(url, options)
      .map((response: Response) => response.json());
  }
  async saveLogLogout(): Promise<any> {
    const token = JSON.parse(localStorage.getItem("currentSmmData")).token;
    // const token = 'abcd';
    return await this.http
      .post(this.host + "/oauth/logout?token=" + token, {})
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/authentication.service.ts